import { mapActions } from 'vuex';
import { STATIC_PAGES } from '@/constants';
import cmsContentMixin from '@/mixins/cmsContent';
import loaderMixin from '@/mixins/loader';
import contentLoaderMixin from '@/mixins/contentLoader';
import staticPageHeader from '@/components/static-page-header/static-page-header.vue';
import seoMetaMixin from '@/mixins/seoMeta';

export default {
  components: { staticPageHeader },
  mixins: [
    cmsContentMixin,
    loaderMixin,
    contentLoaderMixin,
    seoMetaMixin,
  ],
  metaInfo() {
    return this.buildSeoMeta({
      title: 'Platform Announcements',
    });
  },
  methods: {
    ...mapActions('browse', ['getStaticPageFull']),
  },
  created() {
    this.loaderAdd(document.body);
    this.getStaticPageFull(STATIC_PAGES.PLATFORM_ANNOUNCEMENTS)
      .then((data) => {
        this.isComponentReady = true;
        this.installDynamicControls({ data });
      })
      .then(() => this.loaderRemove(document.body))
      .catch(() => {
        this.isComponentReady = true;
        this.loaderRemove(document.body);
      });
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-platform-announcements/page-platform-announcements.js